<template>
  <div>
    <div class="row justify-content-center align-items-center login-top">
      <div class="col-lg-3 p-0 d-none d-lg-block">
        <div class="log-pic">
          <img src="../assets/images/login.jpg" alt />
        </div>
      </div>
      <div class="col-lg-3 p-lg-0">
        <div class="login">
          <img class="log-logo" src="../assets/images/logoMain.png" alt />
          <div class="log-text">
            Gestão de Frotas. Acesse para gerenciar os veículos.
          </div>
          <form action @submit.prevent="login">
            <div class="form-group">
              <label for="inputEmail">E-mail</label>
              <input
                type="email"
                class="form-control"
                id="inputEmail"
                placeholder
                value="admin@innovareti.com.br"
                v-model="email"
              />
            </div>
            <div class="form-group">
              <label for="inputSenha">Senha</label>
              <input
                type="password"
                class="form-control"
                id="inputSenha"
                placeholder
                value="innovareti"
                v-model="password"
                autocomplete="off"
              />
              <small id="ajudaSenha" class="form-text text-muted float-right">
                <a href data-toggle="modal" data-target="#modalSenha"
                  >Esqueci minha senha</a
                >
              </small>
            </div>
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                id="switchLembrar"
              />
              <label class="custom-control-label" for="switchLembrar"
                >Lembrar Senha</label
              >
            </div>
            <button type="submit" class="btn btn-block btn-login">
              Entrar
            </button>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modalSenha"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalSenhaTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalSenhaTitle">
              Esqueci minha senha
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="log-text">
              Insira seu email cadastrado e em instantes você receberá uma nova
              senha.
            </div>
            <form action="" @submit.prevent="forgotPasswor">
              <div class="form-group">
                <input
                  type="email"
                  class="form-control"
                  id="inputEmailPass"
                  placeholder="Email"
                  v-model="forgot.email"
                />
              </div>
              <input
                type="submit"
                class="btn btn-block btn-login"
                value="Enviar"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      forgot: {
        email: "",
        password: "",
      },
      email: "",
      password: "",
    };
  },
  methods: {
    login() {
      const self = this;
      const api = this.$store.state.api + "login";
      self.isLoading = true;

      axios
        .post(api, {
          email: self.email,
          password: self.password,
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          self.$router.push({ path: "/" });
          self.isLoading = false;
        })
        .catch((error) => {
          self.isLoading = false;
          self.$message("Erro", error.response.data, "error");
        });
    },
    forgotPasswor() {
      const self = this;
      const api = this.$store.state.api + "user/recovery";

      axios
        .post(api, {
          email: self.forgot.email,
        })
        .then((response) => {
          $("#modalSenha").modal("hide");
          self.$message(
            "Sucesso",
            "Um e-mail foi enviado com as instruções necessárias",
            "success"
          );
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  components: {
    Loading,
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue